import { Button, Grid, Paper, Stack, Typography } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ClearIcon from "@mui/icons-material/Clear";
import React from "react";
import Select from "../UI/Select";
import { monthList } from "../../util/DateUtil";

const PresencaTableFilter = ({ mesSelect, setMesSelect }) => {
  const onChangeMonth = (event) => {
    setMesSelect(event.target.value);
  };

  const handleClear = () => setMesSelect("");

  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 2, sm: 3 },
        borderRadius: 2,
      }}
    >
      <Stack spacing={2}>
        <Stack direction="row" spacing={1} alignItems="center">
          <FilterAltIcon fontSize="small" color="action" />
          <Typography variant="h6" fontWeight={600}>
            Filtro
          </Typography>
        </Stack>

        <Grid container spacing={2} alignItems="center">
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Select
              label="Por Mês"
              value={mesSelect}
              list={monthList}
              onChange={onChangeMonth}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 12, sm: "auto" }}>
            <Button
              onClick={handleClear}
              disabled={!mesSelect}
              size="small"
              variant="outlined"
              color="secondary"
              startIcon={<ClearIcon fontSize="small" />}
            >
              Limpar Filtro
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </Paper>
  );
};

export default PresencaTableFilter;
